import { message } from 'antd'

/**
 * Processes messages from the AI assistant
 * @param {Object} data - The message data
 * @param {Object} options - Processing options
 * @param {Function} options.onAction - Callback for actions
 * @param {Function} options.setUserSpeaking - State setter for user speaking status
 * @param {Function} options.setIsAISpeaking - State setter for AI speaking status
 * @param {Array} options.actionTriggers - Custom action trigger phrases
 */
export const processAIMessage = (data, { onAction, setUserSpeaking, setIsAISpeaking, actionTriggers = [] }) => {
  // Handle different message types
  switch (data.type) {
    case 'response.audio_transcript.done':
      const transcript = data.transcript
      if (transcript && onAction) {
        // Check for default action triggers
        if (transcript.toLowerCase().includes('letter modal') || transcript.toLowerCase().includes('open letter')) {
          onAction('openLetterModal')
        }

        // Check for custom action triggers
        actionTriggers.forEach((trigger) => {
          const { phrases, action } = trigger
          if (phrases.some((phrase) => transcript.toLowerCase().includes(phrase.toLowerCase()))) {
            onAction(action)
          }
        })
      }
      break

    case 'session.created':
      break

    case 'input_audio_buffer.speech_started':
      setUserSpeaking(true)
      break

    case 'input_audio_buffer.speech_stopped':
      setUserSpeaking(false)
      break

    case 'output_audio_buffer.audio_started':
      setIsAISpeaking(true)
      break

    case 'response.audio.done':
      setIsAISpeaking(false)
      break

    case 'error':
      console.error('Error from AI:', data.error)
      if (data.error?.message) {
        message.error(`AI Error: ${data.error.message}`)
      }
      break

    // Ignore these common events to reduce noise
    case 'input_audio_buffer.committed':
    case 'rate_limits.updated':
    case 'conversation.item.created':
    case 'response.audio_transcript.delta':
    case 'response.content_part.done':
    case 'response.output_item.done':
    case 'response.done':
    case 'output_audio_buffer.audio_stopped':
      break

    default:
      // Only log unhandled events that aren't in the ignore list
      if (!data.type.startsWith('response.') && !data.type.startsWith('conversation.')) {
      }
      break
  }
}
